import React from "react";
import OddsBtn from "@/components/oddsBtn";
import { Maybe, OddsSelection, Scalars } from "@/graphql/gql/graphql";
import Styles from "./Selection.module.scss";

type SelectionProps = {
  oddsValue?: Maybe<Scalars["String"]>;
  onOddsClick: () => void;
} & OddsSelection;

const Selection = ({
  oddsValue,
  runnerName,
  onOddsClick,
  handicap,
}: SelectionProps) =>
  oddsValue ? (
    <div className={Styles.cardContainer}>
      <div className={Styles.selectionName}>{runnerName}</div>
      <OddsBtn
        classButton={Styles.oddsBtn}
        classHandicap={Styles.handicap}
        onClick={onOddsClick}
        odds={oddsValue}
        handicap={handicap}
      />
    </div>
  ) : (
    <React.Fragment />
  );

export default Selection;
